var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.432,
    height: 20.235,
    viewBox: "0 0 28.432 20.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "perfil",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1529",
    "data-name": "Caminho 1529",
    d: "M43.846,60.6a3.245,3.245,0,1,1,3.275-3.245A3.264,3.264,0,0,1,43.846,60.6Zm0-5.579a2.334,2.334,0,1,0,2.364,2.334A2.352,2.352,0,0,0,43.846,55.016Zm0,0",
    transform: "translate(-38.261 -51.026)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1530",
    "data-name": "Caminho 1530",
    d: "M6.9,190.069H1.19A1.188,1.188,0,0,1,0,188.887V187.4a5.6,5.6,0,0,1,8.917-4.437.455.455,0,0,1-.541.733A4.685,4.685,0,0,0,.91,187.4v1.489a.276.276,0,0,0,.279.272H6.9a.455.455,0,1,1,0,.911Zm0,0",
    transform: "translate(0 -171.516)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1531",
    "data-name": "Caminho 1531",
    d: "M340.968,184.018h-5.712a.455.455,0,1,1,0-.911h5.712a.276.276,0,0,0,.279-.272v-1.489a4.652,4.652,0,0,0-4.674-4.619,4.716,4.716,0,0,0-2.959,1.044.455.455,0,1,1-.573-.708,5.63,5.63,0,0,1,3.532-1.247,5.564,5.564,0,0,1,5.584,5.53v1.489a1.188,1.188,0,0,1-1.19,1.182Zm0,0",
    transform: "translate(-313.927 -165.809)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1532",
    "data-name": "Caminho 1532",
    d: "M343.627,56.642A3.245,3.245,0,1,1,346.9,53.4,3.264,3.264,0,0,1,343.627,56.642Zm0-5.579a2.334,2.334,0,1,0,2.365,2.334A2.352,2.352,0,0,0,343.627,51.063Zm0,0",
    transform: "translate(-320.98 -47.298)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1533",
    "data-name": "Caminho 1533",
    d: "M127.111,167h-12.36a1.485,1.485,0,0,1-1.489-1.478v-2.095a7.669,7.669,0,0,1,15.338,0v2.095A1.485,1.485,0,0,1,127.111,167Zm-6.18-10.255a6.728,6.728,0,0,0-6.758,6.682v2.095a.574.574,0,0,0,.578.567h12.36a.574.574,0,0,0,.578-.567v-2.095a6.728,6.728,0,0,0-6.758-6.682Zm0,0",
    transform: "translate(-106.815 -146.962)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1534",
    "data-name": "Caminho 1534",
    d: "M175.49,8.337a4.194,4.194,0,0,1-4.208-4.169,4.209,4.209,0,0,1,8.417,0,4.194,4.194,0,0,1-4.209,4.169Zm0-7.427a3.282,3.282,0,0,0-3.3,3.258,3.3,3.3,0,0,0,6.6,0A3.282,3.282,0,0,0,175.49.91Zm0,0",
    transform: "translate(-161.533)",
    stroke: "#000",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/perfil.f26aa52edba8cc5d7b4171e884169361.svg";
export { ForwardRef as ReactComponent };